// extracted by mini-css-extract-plugin
export default {"main-container":"v2EtVjLj6n2MCilpyXgq","mainContainer":"v2EtVjLj6n2MCilpyXgq"};